import React, { useState, useEffect } from "react";
import { MessagePageStyle } from "./CustomMessage.style";
import TopBar from "../../components/TopBar/TopBar";
import Footer from "../../components/footer/Footer";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { getSubscriptionString } from "../../common/ConvertSubscription";
import { getSubscriptionPlanList } from "../../api/CouponApi";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useDB } from "../../context/DynamoDBContext";
import { useReload } from "../../context/ReloadContext";
import { useSelector } from "react-redux";
import api from "../../api/configAxios";
import Controller from "../../common/controller";
import DateTimePicker from "react-datetime-picker";
import { toast } from "react-toastify";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import moment from "moment";

const CustomMessage = () => {
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const { reload } = useReload();
  const treeDataRed = useSelector((state) => state.treeDataRed);
  const tempData = treeDataRed?.treeData[0]?.children;

  const [users, setUsers] = useState(treeDataRed?.treeData[0]?.children);
  const [allusers, setAllusers] = useState(true);
  const [someUsers, setSomeUsers] = useState(false);
  const [subscription, setSubscription] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [error, setError] = useState("");
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
  const [enableSubscriptionPlan, setEnableSubscriptionPlan] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchData, setSearchData] = useState("");
  const [date, setDate] = useState(new Date());
  const [schedule, setSchedule] = useState(false);
  const [instantmsg, setInstantmsg] = useState(true);
  const [utcDate, setUtcDate] = useState();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (dynamoDBClient) {
      setEnableSubscriptionPlan(true);
    } else {
      setEnableSubscriptionPlan(false);
    }
  }, [dynamoDBClient]);

  const reset = () => {
    setAllusers(true);
    setSomeUsers(false);
    setSubscription(false);
    setBtnDisable(false);
    setError("");
    setSelectedSubscription("");
    setEnableSubscriptionPlan(false);
    setMessage("");
    setSelectedUsers([]);
    setSearchData("");
    setDate(new Date());
    setSchedule(false);
    setInstantmsg(true);
    setUtcDate();
    setUsers(treeDataRed?.treeData[0]?.children);
  };

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["getSubscriptionPlanList"]);
    }
  }, [reload]);

  const sendMessage = async () => {
    setBtnDisable(true);
    setError("");
    if (message === "") {
      setError("Message is a Required Field");
      setBtnDisable(false);
      return;
    }

    if (schedule) {
      const now = moment.utc();
      if (now.isAfter(utcDate)) {
        setBtnDisable(false);
        setError("Please choose a date and time in the future");
        return;
      }
    }

    if (selectedSubscription === "" && subscription) {
      setBtnDisable(false);
      setError("Subscription Plan is a Required Field");
      return;
    }

    if (selectedUsers.length <= 0 && someUsers) {
      setBtnDisable(false);
      setError("Select Users from the List");
      return;
    }

    try {
      var response = await api.post(`${Controller.dynamoDB}/sendFCM`, {
        message: message,
        title: "Ocufii",
        isAllAccounts: allusers,
        email: selectedUsers,
        subscriptionType: selectedSubscription,
        dateTime: schedule
          ? moment(utcDate).format("YYYY-MM-DDTHH:mm:ss.SSSSSS")
          : "",
      });
      if (response.status === 200) {
        reset();
        if (schedule) {
          toast("Message Scheduled Successfully.");
        } else {
          toast("Message Sent Successfully.");
        }
      } else {
        setBtnDisable(false);
        setError("An Error has Ocurred. Try Again");
      }
    } catch (error) {
      setBtnDisable(false);
      setError("An Error has Ocurred. Try Again");
    }
    setBtnDisable(false);
  };

  const { data: subscriptionList } = useQuery({
    queryKey: ["getSubscriptionPlanList"],
    queryFn: () => getSubscriptionPlanList(dynamoDBClient),
    enabled: enableSubscriptionPlan,
    onSuccess: (data) => {
      if (data.length !== 0) {
        setSubscriptionPlanList(data);
      }
      setEnableSubscriptionPlan(false);
    },
    onError: (error) => {
      toast.error("Unable to get Subscription List", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    },
  });

  const filterSearch = (val) => {
    setUsers((data) => {
      const arr = tempData.filter((item) => item.email.includes(val));

      return arr;
    });
  };

  const selectUsers = (email, e) => {
    if (e.target.checked) {
      setSelectedUsers((prevData) => [...prevData, email]);
    } else {
      const filterUser = selectedUsers.filter((item) => item !== email);
      setSelectedUsers(filterUser);
    }
  };

  const dateChage = (val) => {
    setDate(val);
    const localeDate = moment(val).utc();
    setUtcDate(localeDate);
  };

  return (
    <MessagePageStyle>
      <TopBar authorized={true} />
      <MainBodyStyle>
        <HeadingStyle>Custom Message</HeadingStyle>
        <table className="table-div">
          <tbody>
            <tr>
              <td className="field">
                <h6>Message*: </h6>
              </td>
              <td>
                <div className="form-floating">
                  <textarea
                    className="form-control custom-message"
                    placeholder="Message"
                    id="floatingTextarea2"
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={2000}
                    value={message}
                  />

                  <p className="warning">*Character Limit 2000</p>
                </div>
              </td>
            </tr>
            <tr>
              <td className="field">
                <h6>Schedule Notification*: </h6>
              </td>
              <td>
                <div className="radio-div2">
                  <div className="form-check2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioSchedule"
                      id="scheduleNotification"
                      checked={schedule}
                      onChange={() => {
                        setSchedule(true);
                        setInstantmsg(false);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioSchedule"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioInstant"
                      id="instant"
                      checked={instantmsg}
                      onChange={() => {
                        setInstantmsg(true);
                        setSchedule(false);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioInstant"
                    >
                      No
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            {schedule && (
              <tr>
                <td className="field">
                  <h6>Date/Time*: </h6>
                </td>
                <td>
                  <DateTimePicker
                    value={date}
                    className={"date-div"}
                    onChange={dateChage}
                    clearIcon={null}
                    disableClock={true}
                  />
                </td>
              </tr>
            )}

            <tr>
              <td className="field">
                <h6>Mode*: </h6>
              </td>
              <td>
                <div className="radio-div">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="allusers"
                      checked={allusers}
                      onChange={() => {
                        setAllusers(true);
                        setSomeUsers(false);
                        setSubscription(false);
                        setSelectedUsers([]);
                        setSelectedSubscription("");
                      }}
                    />
                    <label className="form-check-label" htmlFor="allusers">
                      All Users
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="someUsers"
                      checked={someUsers}
                      onChange={() => {
                        setAllusers(false);
                        setSomeUsers(true);
                        setSubscription(false);
                        setSelectedSubscription("");
                      }}
                    />
                    <label className="form-check-label" htmlFor="someUsers">
                      Selected Users
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-
                      check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="subscriptionBased"
                      checked={subscription}
                      onChange={() => {
                        setAllusers(false);
                        setSomeUsers(false);
                        setSubscription(true);
                        setSelectedUsers([]);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="subscriptionBased"
                    >
                      Subscription Plan
                    </label>
                  </div>
                </div>
              </td>
            </tr>
            {subscription && (
              <tr>
                <td className="field">
                  <h6>Subscription Plan* :</h6>
                </td>
                <td>
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle dropDown-custom"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {selectedSubscription !== ""
                        ? getSubscriptionString(selectedSubscription)
                        : "Select"}
                    </button>
                    <ul className="dropdown-menu menu2">
                      {subscriptionPlanList.length > 0 ? (
                        subscriptionPlanList.map((data, index) => (
                          <li
                            onClick={() => {
                              setSelectedSubscription(data.SubscriptionId);
                            }}
                            key={index}
                          >
                            <a className="dropdown-item">
                              {getSubscriptionString(data.SubscriptionId)}
                            </a>
                          </li>
                        ))
                      ) : (
                        <li
                          onClick={() =>
                            setError("No Subscription Available. Reload")
                          }
                        >
                          <a className="dropdown-item">No data available</a>
                        </li>
                      )}
                    </ul>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {someUsers && (
          <div className="someUser-box">
            <div className="search-bar">
              <input
                className="search-input"
                type="text"
                placeholder="Search"
                value={searchData}
                onChange={(e) => {
                  setSearchData(e.target.value);
                  filterSearch(e.target.value);
                }}
              />
              {searchData != "" ? (
                <i
                  className="bi bi-x search-icon"
                  onClick={() => {
                    setSearchData("");
                    setUsers(treeDataRed?.treeData[0]?.children);
                  }}
                />
              ) : (
                <i className="bi bi-search search-icon" />
              )}
            </div>
            {users.map((item, index) => {
              let select = selectedUsers.includes(item.email);
              return (
                <div key={index} className="userCheck">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={select}
                      checked={select}
                      id="flexCheckChecked"
                      onChange={(e) => selectUsers(item.email, e)}
                    />
                    <label className="form-check-label">{item.email}</label>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <button
          type="submit"
          className={
            btnDisable
              ? "btn form-button form-button-disable"
              : "btn form-button"
          }
          disabled={btnDisable}
          onClick={sendMessage}
        >
          Send Message
        </button>
        {error !== "" && <TextErrorStyle>{error}</TextErrorStyle>}
      </MainBodyStyle>
      <Footer style="footer" />
    </MessagePageStyle>
  );
};

export default CustomMessage;
